import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-custom-product-technical-charc',
  templateUrl: './custom-product-technical-charc.component.html',
  styleUrls: ['./custom-product-technical-charc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomProductTechnicalCharcComponent implements OnInit {
  product$: Observable<Product>;
  productAttributeList = [
    'manufacturer',
    'arcModel',
    'materialType1',
    'materialType2',
    'arcDimension',
    'arcTotalPieces',
    'arcShapes',
    'arcColours',
    'arcFinishes',
    'arcTechnicalCharacteristics',
    'diameter',
    'capacity',
    'footHeight',
    'rimThickness',
    'totalLength',
    'longBlade',
    'thickness',
    'depth',
    'pressure',
    'quantityCapacityCups',
    'bottomType',
    'nonstickCoating',
    'typeOfNonstick',
    'handlesQuantity',
    'wing',
    'foot',
    'capsQuantity',
    'pommel',
    'handle',
    'handleTypes',
    'arcTypePackaging',
    'arcFinishingPackaging',
    'sapEAN',
    'pfireTypes',
    'dloosePieceLengthCM',
    'dloosePieceWidthCM',
    'dheightOfLoosePieceCM',
    'usesTypes'
  ];

  constructor(protected currentProductService: CurrentProductService) {
  }

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
  }

  isArray(compare): boolean {
    return Array.isArray(compare);
  }

  toCharacters(val): string {
    return val.toString();
  }
}
